/** Tipos y modelo de Incidencias (procesos Medallia §6-7 del mapeo). */

export type IncidentType     = 'INSUMO' | 'EQUIPO' | 'INSTRUMENTAL' | 'ACCESORIO';
export type IncidentPriority = 'ALTA' | 'MEDIA' | 'BAJA';
/** Estado general de la incidencia. */
export type IncidentStatus   = 'NO RESUELTO' | 'RESUELTO';

export const INCIDENT_TYPES: IncidentType[] = ['INSUMO', 'EQUIPO', 'INSTRUMENTAL', 'ACCESORIO'];
export const INCIDENT_PRIORITIES: IncidentPriority[] = ['ALTA', 'MEDIA', 'BAJA'];
export const INCIDENT_STATUSES: IncidentStatus[] = ['NO RESUELTO', 'RESUELTO'];

/** Traduce estados viejos (REPORTADA / EN REVISION / RESUELTA) al estado general. */
export function incidentStatus(status: string | null | undefined): IncidentStatus {
  const s = String(status ?? '').trim().toUpperCase();
  return (s === 'RESUELTO' || s === 'RESUELTA') ? 'RESUELTO' : 'NO RESUELTO';
}

/** La prioridad solo aplica a equipo e instrumental (la pone el técnico al reportar). */
export const PRIORITY_TYPES = ['EQUIPO', 'INSTRUMENTAL'];

/** Motivos del forms para incidencia de insumos. */
export const INSUMO_REASONS = ['2DA USB', 'CALIDAD', 'OTRO'];

export interface IncidentPiece {
  stock: string; product?: string | null; code?: string | null; description?: string | null;
  batch?: string | null; tagRfid?: string | null; warehouse?: string | null;
  source: 'FOLIO' | 'LOCKER'; prevStatus?: string | null;
  /** "Folio TME-12" / "Remisión R-3" / "Locker L1". */
  origin?: string | null;
}

export interface Incident {
  id?:                string;
  folio?:             string;          // INC-n (auto backend)
  type:               IncidentType;
  interventionFolio?: string | null;   // TME-n de la cirugía (insumos)
  hospitalService?:   string | null;   // id de hospitalServices
  place?:             string | null;   // id del hospital (Ubicaciones)
  doctor?:            string | null;   // id del médico
  reason?:            string | null;   // motivo (insumos)
  description:        string;
  equipmentName?:     string | null;   // etiqueta legible de la pieza
  catalogItem?:       string | null;   // id en equipments / instrumentals / products
  tagRfid?:           string | null;   // etiqueta RFID (insumo)
  serialNumber?:      string | null;
  needsReplacement?:  boolean | null;
  priority?:          IncidentPriority | null;
  status?:            IncidentStatus;
  resolution?:        string | null;
  resolvedOn?:        string | null;
  reportedByName?:    string | null;
  reportedBy?:        string | null;   // lo pone el servidor
  photos?:            string[];        // keys de S3 (evidencia)
  mpxr?:              string | null;   // Representante / Administrador
  mpxrBy?:            string | null;
  mpxrOn?:            string | null;
  justified?:         boolean;
  justifiedBy?:       string | null;
  justifiedOn?:       string | null;
  batch?:             string | null;   // lote (de la etiqueta o capturado)
  productCode?:       string | null;   // lo pone el servidor
  productDescription?: string | null;
  qualityClass?:      'CALIDAD' | 'NO CALIDAD' | null;   // modelo o corrección manual
  qualityScore?:      number | null;
  qualitySource?:     'MODELO' | 'MANUAL' | null;
  qualityBy?:         string | null;
  /** Insumos no conformes (piezas que pasan a "No conforme"). */
  pieces?:            IncidentPiece[];

  organization?: string;
  createdOn?:    string;
  createdBy?:    string;
  modifiedOn?:   string;
  modifiedBy?:   string;
  deleted?:      boolean;
  operationType?: 'single' | 'bulk';
}
